import React from "react";
import { BrieAITool } from "../../../types/BrieInterfaces";

interface Props {
  tool: BrieAITool;
  onClick: () => void;
}

const BrieToolCard = ({ tool, onClick }: Props) => {
  return (
    <div
      key={tool.key}
      className="d-flex flex-column justify-content-center align-items-center cursor-pointer p-2 rounded"
      onClick={onClick}
      style={{
        width: "248px",
        height: "148px",
        boxShadow: "1px 1px 2px 2px rgba(132, 133, 132, 0.2)",
      }}
    >
      <i
        className={`${tool.icon}`}
        style={{ fontSize: "23px", marginBottom: "8px" }}
      ></i>
      <span
        style={{
          fontSize: "16px",
          fontWeight: 700,
          marginBottom: "8px",
        }}
      >
        {tool.title}
      </span>
      <p
        style={{
          fontSize: "14px",
          fontWeight: 400,
          textAlign: "center",
        }}
      >
        {tool.description}
      </p>
    </div>
  );
};

export default BrieToolCard;
